import {ConsultantBoxType} from "../types/ConsultantBoxType";
import {IConsultantInfo} from "../types/IConsultantInfo";

export const getConsultantInfoFromType = (type?: ConsultantBoxType): IConsultantInfo => {
    const baseInfo = {name: "Maria Kowalska"};
    switch (type) {
        case ConsultantBoxType.PHONE:
            return {...baseInfo, title: "Konsultant mieszkaniowy", phone: {label: "+48 678 762 389", href: "678 762 389"}};
        case ConsultantBoxType.BASE:
        default:
            return {...baseInfo, title: "Konsultant rynekpierwotny.pl"};
    }
};
import {ConsultantBoxType} from "../types/ConsultantBoxType";
import {IConsultantInfo} from "../types/IConsultantInfo";

export const getConsultantInfoFromType = (type?: ConsultantBoxType): IConsultantInfo => {
    const baseInfo = {name: "Maria Kowalska"};
    switch (type) {
        case ConsultantBoxType.PHONE:
            return {...baseInfo, title: "Konsultant mieszkaniowy", phone: {label: "+48 678 762 389", href: "678 762 389"}};
        case ConsultantBoxType.BASE:
        default:
            return {...baseInfo, title: "Konsultant rynekpierwotny.pl"};
    }
};
